export default __webpack_public_path__ + "static/media/supper_apps_s1.4372f4d6.png";